import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ConfigurationManager} from 'src/app/data/manager/configuration/configuration.manager';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';
import {AddressManager} from '../../data/manager/customer/address/address.manager';
import {DeliveryTypeEnum} from '../../data/networking/models/location/enum/delivery-type.enum';
import {LocationManager} from '../../data/manager/location/location.manager';
import {SessionStorageManager} from '../../data/manager/session-storage/session-storage.manager';
import { countryConfig } from 'src/country-config/country-config';
import { PrimeManager } from 'src/app/data/manager/prime/prime.manager';
import { LocalStorageManager } from 'src/app/data/manager/local-storage/local-storage.manager';
import { CreditCardManager } from 'src/app/data/manager/customer/credit-card/credit-card.manager';
import { CartManager } from 'src/app/data/manager/cart/cart.manager';
import { FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';
import { FirebaseManager } from 'src/app/data/manager/firebase/firebase.manager';

@Injectable({
  providedIn: 'root',
})
export class CustomerProfileVm {
  public customer;
  constructor(
    private customerManager: CustomerManager,
    private addressManager: AddressManager,
    private ssm: SessionStorageManager,
    private lsm: LocalStorageManager,
    private locationManager: LocationManager,
    private configurationManager: ConfigurationManager,
    private primeManager : PrimeManager,
    private creditCardManager: CreditCardManager,
    private cartManager: CartManager,
    private firebaseManager: FirebaseManager,
  ) {}

  hasCustomer() {
    return this.customerManager.hasValidCustomer();
  }

  getCustomer() {
    const {customer} = this.customerManager;
    if (customer?.customerId) {
      const phone = customer.phone.toString();
      if (phone.length > 10) {
        customer.prefix = phone.substring(0, 2);
        customer.phone = phone.substring(2, phone.length);
      }
    }
    return customer;
  }

  saveCustomerProfile(data): Observable<any> {
    return this.customerManager.update(data);
  }

  getCustomerAddresses(): Observable<any> {
      const deliveryAddress = this.addressManager.getDeliveryAddress();
      return this.addressManager.get()
        .pipe(map(res => {
          let express = [];
          let national = [];
          let envialoYa = [];

          res.forEach(address => {
            address = {...address, default: deliveryAddress && address.idAddress === deliveryAddress.idAddress};
            address.active = true;
            switch (address.deliveryType) {
              case DeliveryTypeEnum.EXPRESS:
                express = [...express, address];
                break;
              case DeliveryTypeEnum.NATIONAL:
                national = [...national, address];
                break;
              case DeliveryTypeEnum.ENVIALOYA:
                envialoYa = [...envialoYa, address];
                break;
              default:
                express = [...express, address];
                break;
            }
          });
          let groups = [];
          if (express.length > 0) {
            groups = [...groups, express];
          }
          if (national.length > 0) {
            groups = [...groups, national];
          }
          if (envialoYa.length > 0) {
            groups = [...groups, envialoYa];
          }
          return groups;
        }));
  }

  addressHeaders(): Observable<any> {
    return this.locationManager.getDeliveryTypeText()
      .pipe(map(response => {
        const headers = {};
        let texts: any = {};
        if (response && response.deliveryTimeLabelGeneric) {
          texts = response.deliveryTimeLabelGeneric;
        } else {
          texts[DeliveryTypeEnum.EXPRESS] = countryConfig.deliveryTime;
          texts[DeliveryTypeEnum.NATIONAL] = '72 horas';
          texts[DeliveryTypeEnum.ENVIALOYA] = '5 a 10 días';
        }

        headers[DeliveryTypeEnum.EXPRESS] = {
          text: texts[DeliveryTypeEnum.EXPRESS],
          icon: 'assets/svg/icon-moto-blue.svg',
        };

        headers[DeliveryTypeEnum.NATIONAL] = {
          text: texts[DeliveryTypeEnum.NATIONAL],
          icon: 'assets/svg/icon-truck-blue.svg',
        };

        headers[DeliveryTypeEnum.ENVIALOYA] = {
          text: texts[DeliveryTypeEnum.ENVIALOYA],
          icon: 'assets/svg/icon-airplane-blue.svg',
        };

        return headers;
      }));
  }

  deleteAddress(addressId): Observable<any> {
    return this.addressManager.delete(addressId);
  }

  isLifeMilesEnabled() {
    return this.ssm.get('lifeMilesEnabled');
  }

  getGeneralConf() {
    const conf = this.ssm.get('multiCountry');
    return !!conf ? conf.general : {};
  }

  getConfiguration(): any {
    return this.configurationManager.getConfigurationModule('profile');
  }

  getCountryConfigAloglia() {
    return this.ssm.get('multiCountry');
  }

  getPrimeSubscription():Observable<any>{
    this.customer = this.lsm.get("customer");
    if(this.customer?.id){
      return this.primeManager.getPrimeSubscription(this.customer?.id);
    }
    return of({ active: false })
  }

  getCreditCart(id){
    return this.creditCardManager.updateCreditCard(id);
  }

  getCreditsTalonOne(){
    return this.cartManager.getCreditsTalonOne();
  }

  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseManager.getRemoteConfig();
  }
}
